module.exports = {
	wordholder:'请输入门店名称搜索',
	stateholder:'请选择门店状态',
	add:'添加门店',
	name:'门店名称',
	icon:'门店图片',
	nameholder:'请输入门店名称',
	infoholder:'请输入门店说明',
	namemsg:'门店名称不能为空',
	state:{
		open:'营业',
		close :'休息',
	}
}


// WEBPACK FOOTER //
// ./src/i18n/locales/en-us/modules/shop.js